import React from "react";

const SubscriptionCardContent = (props) => {
  const { cost, ticketsCount, discount, label, isDoublePrize } = props;

  const ticketsData = (
    <div className="subscription-card-body__header-price-row-inner">
      <span>{ticketsCount / 3} tickets</span>
      <span>{ticketsCount} tickets</span>
    </div>
  );

  const parseTotalCost = () => {
    let costValue = cost;
    if (String(costValue).includes(".")) {
      return `£${costValue.toFixed(2)}`;
    }
    return `£${costValue}`;
  }

  const getTicketPrice = () => {
    if (ticketsCount) {
      let costValue = (discount && discount.status === true && cost !== 10) ? cost * discount.value : cost;
      const tiketCost = (costValue * 100) / ticketsCount;
      if (isDoublePrize) {
        return Math.ceil((tiketCost - 0.3) / 2);
      } else {
        return Math.floor(tiketCost);
      }
    } else return null;
  };

  const parseDiscountCost = () => {
    let costValue;
    if (discount && discount.status === true && cost !== 10) {
      costValue = cost * discount.value;
    } else {
      costValue = cost;
    }
    if (String(costValue).includes(".")) {
      return `£${costValue.toFixed(2)}`;
    }
    return `£${costValue}`;
  }
  return (
    <div className="subscription-card-body__header">
    { label ? <span className="subscription-card-body__header-label">{label}</span> : null}
      <div className="subscription-card-body__header-details">
        <div className="subscription-card-body__header-price-row">
          {discount && discount.status === true ? (
            <p className="subscription-card-body__header-crossed-out-cost">{parseTotalCost()}</p>
          ) : undefined}
          {discount && discount.status === true ? (
            <p>{parseDiscountCost()}</p>
          ) : (
            <p>{parseTotalCost()}</p>
          )}
          <span>/month</span>
        </div>
        <span className="ticket-price">Only {getTicketPrice()}p per ticket</span>
        {ticketsData}
      </div>
    </div>
  );
};

export default SubscriptionCardContent;
